import PropTypes from 'prop-types';
import React, { Component } from 'react';
import get from 'lodash/get';
import { withMfeComponents } from 'yoda-app-shell/lib/mfe/MfeLoader/withMfeComponents';
import { federatedComponents } from 'config/federatedComponents';
import Button from 'yoda-core-components/lib/components/Button';
import Switch from 'yoda-core-components/lib/components/Switch/Switch';
import ClassNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { YodaContext } from 'yoda-site-components/lib/components/ContextProvider/ContextProvider';
import * as styles from './Preferences.css';

const cx = ClassNames.bind(styles);

class EmailNotificationPreferences extends Component {
    static propTypes = {
        marketingEmail: PropTypes.objectOf(PropTypes.string).isRequired,
        checkboxConfigRating: PropTypes.objectOf(PropTypes.string).isRequired,
        checkboxConfigSurvey: PropTypes.objectOf(PropTypes.string).isRequired,
        emailSubscribeErrorText: PropTypes.string.isRequired,
        emailButtonClicked: PropTypes.func.isRequired,
        checkboxClicked: PropTypes.func.isRequired,
        messagesTexts: PropTypes.objectOf(PropTypes.object).isRequired,
        featureFlags: PropTypes.objectOf(PropTypes.any).isRequired,
        submitNotification: PropTypes.func.isRequired,
        isEmailNotificationsActive: PropTypes.bool,
        setEmailNotificationsActive: PropTypes.func,
        enableEmailSubscriptionSaveButton: PropTypes.bool,
        enableFeedbackEmailSubscriptionSaveButton: PropTypes.bool,
    };

    static defaultProps = {
        isEmailNotificationsActive: false,
        setEmailNotificationsActive: () => {},
        enableEmailSubscriptionSaveButton: false,
        enableFeedbackEmailSubscriptionSaveButton: false,
    };

    static contextType = YodaContext;

    /* istanbul ignore next */
    onEmailSubscriptionChange = (isSubscribed) => {
        if (typeof isSubscribed === 'object') {
            this.props.emailButtonClicked(isSubscribed?.target?.checked);
        } else {
            this.props.emailButtonClicked(isSubscribed);
        }
    };

    onFeedbackEmailSubscriptionChange = (isSubscribed) => {
        this.props.checkboxClicked(isSubscribed);
    };

    toggleEmailNotifications = () => {
        this.props.setEmailNotificationsActive(!this.props.isEmailNotificationsActive);
    };

    render() {
        const {
            marketingEmail,
            checkboxConfigRating,
            checkboxConfigSurvey,
            submitNotification,
            emailSubscribeErrorText,
            messagesTexts,
            isEmailNotificationsActive,
            enableEmailSubscriptionSaveButton,
            enableFeedbackEmailSubscriptionSaveButton,
            featureFlags,
        } = this.props;
        const { deviceType: { isMobile } = {} } = this.context;
        const { CheckBox, MessageBox } = this.props.mfeComponents || {};
        const isSubscribed = marketingEmail.status;
        const switchLabel = isSubscribed ? 'On' : 'Off';
        return (
            <div className={cx('preferences')}>
                <div
                    className={cx(
                        'notifyAccordion',
                        isEmailNotificationsActive || !isMobile ? 'active' : 'inActive'
                    )}
                >
                    {get(featureFlags, 'enableMarketingEmails', true) && (
                        <div className={cx('notify')}>
                            <div
                                className={`${cx('notifyInnerContent', 'firstSection')} ${dt([
                                    'pb-6',
                                    'mb-6',
                                    'border-b',
                                    'border-solid',
                                    'border-gray-15',
                                    'text-black',
                                ])}`}
                            >
                                <h2
                                    className={`${cx('notifyHeading')} ${dt([
                                        'text-large',
                                        'mb-4',
                                        'font-open-sans-semibold',
                                    ])}`}
                                >
                                    {get(messagesTexts, 'emailNotifications.marketingTexts.title')}
                                </h2>
                                <div className={cx('notifyInnerEmailContent')}>
                                    <div className={cx('subscribeContent')}>
                                        <p
                                            className={`${cx('saveExtraText')} ${dt([
                                                'text-normal',
                                                'mb-4',
                                            ])}`}
                                        >
                                            {get(
                                                messagesTexts,
                                                'emailNotifications.marketingTexts.saveExtraText'
                                            )}
                                            <span className={`${cx('seeOffer')} ${dt(['block'])}`}>
                                                <a
                                                    className={dt(['underline'])}
                                                    href={get(messagesTexts, 'offerDetailsLink')}
                                                >
                                                    {get(
                                                        messagesTexts,
                                                        'emailNotifications.marketingTexts.seeOfferText'
                                                    )}
                                                </a>
                                            </span>
                                        </p>
                                        {emailSubscribeErrorText && MessageBox && (
                                            <div id="messageBox" className={dt(['mb-4'])}>
                                                <MessageBox
                                                    type="error"
                                                    level="inline"
                                                    title={emailSubscribeErrorText}
                                                    data-automation-id="at-accPO-InlineErrorMsg"
                                                />
                                            </div>
                                        )}
                                        <div
                                            className={`${cx('subscribeContent')} ${dt(['mb-4'])}`}
                                        >
                                            <Switch
                                                onClick={this.onEmailSubscriptionChange}
                                                config={{
                                                    checked: isSubscribed,
                                                    id: 'subscribeEmail',
                                                    automationId: 'subscribeEmail',
                                                    circleClassName: cx('subscribeSwitch'),
                                                }}
                                            >
                                                {`Subscription ${switchLabel}`}
                                            </Switch>
                                        </div>
                                    </div>
                                    <div
                                        className={`${cx('subscribeText')} ${dt([
                                            'mb-4',
                                            'text-xsmall',
                                            'text-gray-60',
                                        ])}`}
                                    >
                                        {get(
                                            messagesTexts,
                                            'emailNotifications.marketingTexts.subscribeText[0]'
                                        )}
                                    </div>
                                    <div
                                        className={`${cx('subscribeText')} ${dt([
                                            'mb-4',
                                            'text-xsmall',
                                            'text-gray-60',
                                        ])}`}
                                    >
                                        {get(
                                            messagesTexts,
                                            'emailNotifications.marketingTexts.subscribeText[1]'
                                        )}
                                        <span className={dt(['block', 'mt-4'])}>
                                            <a
                                                className={dt(['underline'])}
                                                href={get(messagesTexts, 'privacyPolicyLink')}
                                            >
                                                {get(messagesTexts, 'viewPrivacy')}
                                            </a>
                                        </span>
                                    </div>
                                </div>
                                <div className={`${cx('save')} ${dt(['flex', 'justify-end'])}`}>
                                    <Button
                                        isDisabled={!enableEmailSubscriptionSaveButton}
                                        className={`${cx('button')} ${dt([
                                            'smOnly:!w-full',
                                            'md:!w-[154px]',
                                        ])}`}
                                        onClick={() => submitNotification('emailSubscription')}
                                    >
                                        {get(messagesTexts, 'saveButtonText')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                    {get(featureFlags, 'enableFeedbackEmails', true) && (
                        <div className={cx('notify')}>
                            <div
                                className={`${cx('notifyInnerContent', 'firstSection')} ${dt([
                                    'pb-6',
                                    'mb-6',
                                    'border-b',
                                    'border-solid',
                                    'border-gray-15',
                                    'text-black',
                                ])}`}
                            >
                                <h2
                                    className={`${cx('notifyHeading')} ${dt([
                                        'text-large',
                                        'mb-4',
                                        'font-open-sans-semibold',
                                    ])}`}
                                >
                                    {get(messagesTexts, 'emailNotifications.feedbackTexts.title')}
                                </h2>
                                <div className={cx('notifyInnerEmailContent')}>
                                    <div className={`${cx('checkBoxContainer')} ${dt(['mb-4'])}`}>
                                        {CheckBox && (
                                            <CheckBox
                                                id="survey"
                                                label={get(
                                                    messagesTexts,
                                                    'emailNotifications.feedbackTexts.surveyLabel'
                                                )}
                                                onChange={this.onFeedbackEmailSubscriptionChange}
                                                onClick={this.onFeedbackEmailSubscriptionChange}
                                                // eslint-disable-next-line react/jsx-props-no-spreading
                                                    {...checkboxConfigSurvey}
                                            />
                                        )}


                                    </div>
                                    <div className={`${cx('checkBoxContainer')} ${dt(['mb-4'])}`}>
                                        {CheckBox && (
                                            <CheckBox
                                                id="rating"
                                                label={get(
                                                    messagesTexts,
                                                    'emailNotifications.feedbackTexts.ratingLabel'
                                                )}
                                                onChange={this.onFeedbackEmailSubscriptionChange}
                                                onClick={this.onFeedbackEmailSubscriptionChange}
                                                // eslint-disable-next-line react/jsx-props-no-spreading
                                                    {...checkboxConfigRating}
                                            />
                                        )}


                                    </div>
                                </div>
                                <div className={`${cx('save')} ${dt(['flex', 'justify-end'])}`}>
                                    <Button
                                        isDisabled={!enableFeedbackEmailSubscriptionSaveButton}
                                        className={`${cx('button')} ${dt([
                                            'smOnly:!w-full',
                                            'md:!w-[154px]',
                                        ])}`}
                                        onClick={() =>
                                            submitNotification('feedbackEmailSubscription')
                                        }
                                    >
                                        {get(messagesTexts, 'saveButtonText')}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default withMfeComponents(['CheckBox', 'MessageBox'], federatedComponents)(EmailNotificationPreferences);
